import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-staff',
  templateUrl: './staff.component.html',
  styleUrls: ['./staff.component.scss']
})
export class StaffComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }
  gotoAbout() {
    this.router.navigateByUrl('/about');
  }
  gotoAboutCriteria() {
    this.router.navigateByUrl('/about/criteria');
  }
  gotoAboutCommittee() {
    this.router.navigateByUrl('/about/committee');
  }
  gotoAboutGroups() {
    this.router.navigateByUrl('/about/groups');
  }
  gotoAboutStaff() {
    this.router.navigateByUrl('/about/staff');
  }
  gotoAboutExample1() {
    this.router.navigateByUrl('/about/staff');
  }
  gotoAboutExample2() {
    this.router.navigateByUrl('/about/staff');
  }
  gotoAboutExample3() {
    this.router.navigateByUrl('/about/staff');
  }

}
